import { Injectable } from '@angular/core';
import { NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { LogType } from '../enums/log-type.enum';
/**
 * 使用者操作軌跡紀錄
 */
@Injectable({
  providedIn: 'root',
})
export class UserTraceLogService {
  logLevelKeyMap = {
    0: 'trace',
  };
  constructor(private logger: NGXLogger) {}
  //交易內user trace log
  logStack = new Map<Date, any>();
  public setTraceLog(
    logType: LogType,
    logInfoMap: Record<string, any>,
    logLevel?: NgxLoggerLevel
  ) {
    const useObj = {} as any;
    useObj[logType] = logInfoMap;
    this.logStack.set(new Date(), useObj);
    if (!logLevel) {
      this.logger.info(logType, logInfoMap);
    } else {
      switch (logLevel as number) {
        case NgxLoggerLevel.TRACE:
          this.logger.trace(logType, logInfoMap);
          break;
        case NgxLoggerLevel.DEBUG:
          this.logger.debug(logType, logInfoMap);
          break;
        case NgxLoggerLevel.WARN:
          this.logger.warn(logType, logInfoMap);
          break;
        case NgxLoggerLevel.ERROR:
          this.logger.error(logType, logInfoMap);
          break;
        case NgxLoggerLevel.INFO:
          this.logger.info(logType, logInfoMap);
          break;
        default:
          break;
      }
    }
  }
  public getAllTraceLog() {
    return this.logStack;
  }
  public clearAllTraceLog() {
    this.logStack = new Map<Date, any>();
  }
}
